import styled, { createGlobalStyle } from "styled-components";
import { colorsPalettes, fonts, mixins } from "@similarweb/styles";
import { RadioSelect } from "app/pages/sales-intelligence/common-components/form-fields";

export const CUSTOM_MODAL_STYLES = {
    content: { padding: 0, width: 592 },
};

export const StyledModalGlobal = createGlobalStyle`
    .PlainTooltip-element {
        z-index: 1121 !important;
    }
`;

export const StyledButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 16px;

    & > *:not(:first-child) {
        margin-left: 4px;
    }
`;

export const StyledRadioContainer = styled(RadioSelect)`
    align-items: center;
    display: flex;
    margin-bottom: 24px;
`;

export const StyledMainContainer = styled.div`
    flex-grow: 1;
    padding: 5px 24px 8px;
`;

export const StyledSubtitle = styled.p`
    ${mixins.setFont({ $size: 13, $color: colorsPalettes.carbon["400"] })};
    line-height: 16px;
    margin: 8px 0 0;
`;

export const StyledTitle = styled.h2`
    ${mixins.setFont({
        $size: 20,
        $color: colorsPalettes.carbon["500"],
        $family: fonts.$dmSansFontFamily,
        $weight: 500,
    })};
    line-height: 24px;
    margin: 0;
`;

export const StyledHeader = styled.div`
    padding: 20px 24px;
`;

export const StyledModalContent = styled.div`
    display: flex;
    flex-direction: column;
`;
